import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import AnimateButton from 'components/@extended/AnimateButton'
import { TextField } from 'components/@extended/TextField'
import React, { useEffect, useState } from 'react'

interface CopyPackageDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: (newName: string) => void
  originalName: string
  isLoading: boolean
}

const CopyPackageDialog: React.FC<CopyPackageDialogProps> = ({ open, onClose, onSubmit, originalName, isLoading }) => {
  const [name, setName] = useState('')

  useEffect(() => {
    if (open) {
      setName(`${originalName} (Copy)`)
    }
  }, [open, originalName])

  const handleSubmit = () => {
    onSubmit(name)
  }

  const isValid = name.trim() !== '' && name.trim() !== originalName

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Copy Package</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          name="name"
          label="New Package Name"
          variant="outlined"
          pill
          shrink
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          helperText="Enter a unique name for the copied package"
        />
      </DialogContent>
      <DialogActions>
        <AnimateButton>
          <Button variant="contained" color="warning" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
        </AnimateButton>

        <AnimateButton>
          <Button variant="contained" color="primary" onClick={handleSubmit} disabled={isLoading || !isValid}>
            {isLoading ? 'Copying...' : 'Copy'}
          </Button>
        </AnimateButton>
      </DialogActions>
    </Dialog>
  )
}

export default CopyPackageDialog
